module.exports = __webpack_public_path__ + "static/media/ribbon_g.622f33f1.svg";